/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import uploadSocioEcoFileActions, {
    uploadSocioEcoFileTypes,
} from '../../../redux/donneesSocioEconomique/uploadSocioEcoFile'
import { Post } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* uploadSocioEcoFileSagas({ response }) {
    try {
        const res = yield Post(`csv/economic_data`, response.fileData)
        if (res.status === 200) {
            yield all([
                yield put(
                    uploadSocioEcoFileActions.uploadSocioEcoFileSuccess(
                        res.data
                    )
                ),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: null,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
            ])
        } else {
            yield put(uploadSocioEcoFileActions.uploadSocioEcoFileFailure(res))
        }
    } catch (error) {
        yield put(uploadSocioEcoFileActions.uploadSocioEcoFileFailure(error))
    }
}

export function* uploadSocioEcoFileSaga() {
    yield takeLatest(
        uploadSocioEcoFileTypes.UPLOAD_SOCIO_ECO_FILE_REQUEST,
        uploadSocioEcoFileSagas
    )
}
